const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    userProfile: {
      fontSize: 16,
    },
    playerAvatarSection: {
      cursor: 'pointer',
    },
    playerIconContainer: {
      position: 'relative',
      width: 'fit-content',
      height: 80,
    },
    countryIcon: {
      height: 25,
      position: 'absolute',
      bottom: 0,
      right: 0,
    },
    userStatusContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      rowGap: 10,
    },
    skeleton: {
      width: '100%',
      height: 20,
      borderRadius: 5,
    },
    onlineStatus: {
      color: '#24CB8D',
    },
    borderContainer: {
      background:
        // eslint-disable-next-line max-len
        'linear-gradient(47.55deg, #F3B331 26.99%, #945C0B 37.17%, #FBF18E 47.35%, #F3B331 57.53%, #FBF18E 67.71%, #F3B331 77.89%)',
      borderRadius: '3px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '1px',
      width: 'fit-content',
    },
    proStatus: {
      padding: [0, 5],
      background:
        'linear-gradient(170.55deg, #F0D260 7%, #A06F15 35.62%, #D4A73D 64.25%, #A17203 92.87%)',
      boxShadow: ' inset 0px 0px 5px rgba(255, 234, 152, 0.42)',
      borderRadius: '3px',
      fontWeight: '600',
      fontSize: '12px',
      lineHeight: '16px',
      textAlign: 'center',
    },
    userName: {
      fontSize: 16,
      fontWeight: '600',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    addressArea: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      whiteSpace: 'nowrap',
    },
    addressText: {
      fontSize: 12,
      opacity: 0.5,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    addressImg: {
      marginRight: 5,
      height: 20,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
